module.exports = {

  isArray: function(value) {
    if (Array.isArray) {
      return Array.isArray(value);
    }
    // fallback for older browsers like  IE 8
    return Object.prototype.toString.call( value ) === '[object Array]';
  }

};



//////////////////
// WEBPACK FOOTER
// ./~/xml-js/lib/array-helper.js
// module id = ./node_modules/xml-js/lib/array-helper.js
// module chunks = 5